module.exports = __webpack_public_path__ + "static/media/3.bb7df0a8.jpg";